<template>
  <b-icon icon="eye" @click="click" />
</template>

<script>
export default { name: "ViewIcon", methods:{ click(){ this.$emit("click"); }} }
</script>
